<template>
  <div>
    <div class="first-letter-capital">
      <span data-test="label" class="mr-3" :class="color">{{translate(label)}}</span>

      <HelpTooltip :label="help" data-test="help" />
    </div>

    <div data-test="hint" v-if="exists(hint)" :class="hintColor" class="hint font-italic font-weight-light first-letter-capital">{{translate(hint)}}</div>

    <div data-test="error" v-if="errorMessage" class="error-message text-red">{{translate(errorMessage)}}</div>
  </div>
</template>

<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { InternationalizedLabel } from '@/interfaces/InternationalizedLabel';
import TranslateMixin from '@/components/Mixins/TranslateMixin.vue';
import HelpTooltip from '@/components/HelpTooltip.vue';

@Component({
  components: { HelpTooltip }
})
export default class QuestionLabel extends Mixins(TranslateMixin) {
  @Prop({ type: [Object, String], default: '' })
  public readonly label!: InternationalizedLabel;

  @Prop({ type: [Object, String], default: '' })
  public readonly hint!: InternationalizedLabel;

  @Prop({ type: [Object, String], default: '' })
  public readonly help!: InternationalizedLabel;

  @Prop({ type: [Object, String], default: null })
  public readonly errorMessage!: InternationalizedLabel | null;

  get color(): string {
    return this.errorMessage ? 'text-red' : 'text-blue';
  }

  get hintColor(): string {
    return this.errorMessage ? 'text-red' : 'text-grey';
  }
}
</script>

<style lang="scss" scoped>
@import "src/main";

.text-blue {
  color: $blue-title;
}

.text-red {
  color: $red;
}

.text-grey {
  color: $grey + '88';
}

.hint {
  font-size: 14px;
}

.error-message {
  font-size: 12px;
}
</style>
